import React, { useState } from 'react';
import { Layout } from '../../src/integrated-components/_common/Layout';
import { SettingsPage } from '../../src/integrated-components/settings';
import { useEnhancedRouter } from '../../router';

export default function Page() {
  const router = useEnhancedRouter();
  const [initTab, setInitTab] = useState('integrations');
  React.useEffect(() => {
    const tab = Array.isArray(router.query?.tab) ? router.query?.tab.join('') : router.query?.tab;
    setInitTab(tab || 'integrations');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router.query]);
  return (
    <>
      <Layout centered>
        <SettingsPage
          activeTab={initTab}
        />
      </Layout>
    </>

  );
}
